// store/balance/useBalanceStore.ts

import { create } from 'zustand';
import { persist, combine } from 'zustand/middleware';
import { PointsSuspensInitialState, PointsSuspensState } from './pointsSuspensInitialState';
import { createPointsSuspensSlice, PointsSuspensActions } from './createPointsSuspensSlice';

/**
 * @french
 * Hook Zustand persistant pour la gestion de la questionnaire.
 */
export const usePointsSuspensStore = create<PointsSuspensState & PointsSuspensActions>()(
  persist(combine(PointsSuspensInitialState, createPointsSuspensSlice as any), {
    name: 'points-suspens-store',
  }),
);
